// Mock Data for EMRE TİCARET Website

export const contactInfo = {
  phones: [
    { number: '0530 013 72 82', label: 'Cep 1' },
    { number: '0534 564 41 43', label: 'Cep 2' },
    { number: '0232 348 61 63', label: 'Sabit Hat' }
  ],
  address: '266 Sk. No:49/A Bayraklı – İZMİR (Özkanlar Pazaryeri İçi)',
  email: 'info@emreticaret.com',
  instagram: 'https://www.instagram.com/emree_ticaret',
  whatsapp: '905345644143',
  mapCoordinates: { lat: 38.4631, lng: 27.1659 }
};

export const services = [
  {
    id: 'su-kacagi',
    title: 'Su Kaçağı Tespiti',
    shortDesc: 'Kırmadan, kameralı sistemlerle nokta atışı tespit',
    description: 'Termal görüntüleme ve akustik dinleme cihazlarıyla duvarlarınızı kırmadan su kaçaklarını tespit ediyoruz. Profesyonel ekipmanlarımız sayesinde kaçak noktasını milimetre hassasiyetle buluyoruz.',
    features: [
      'Kameralı görüntüleme sistemleri',
      'Termal kamera ile tespit',
      'Akustik dinleme cihazları',
      'Aynı gün çözüm garantisi',
      'Gereksiz kırma işlemi yok'
    ],
    image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=800',
    icon: 'droplet'
  },
  {
    id: 'kanal-acma',
    title: 'Kanal Açma & Tıkanıklık Giderme',
    shortDesc: 'Görüntülü sistemlerle hızlı ve kalıcı çözüm',
    description: 'Tuvalet, banyo, mutfak ve ana kanalizasyon hatlarınızdaki tıkanıklıkları görüntülü sistemlerle açıyoruz. Sorunun kaynağını tespit ederek kalıcı çözümler sunuyoruz.',
    features: [
      'Görüntülü tıkanıklık açma',
      'Yüksek basınçlı makine ile temizlik',
      'Ana kanalizasyon hattı açma',
      'Mutfak ve banyo giderleri',
      'Kötü koku giderme'
    ],
    image: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=800',
    icon: 'pipe'
  },
  {
    id: 'petek-temizleme',
    title: 'Petek Temizleme & Isıtma Sistemleri',
    shortDesc: 'Verimli ısınma için profesyonel petek bakımı',
    description: 'Peteklerinizin içindeki kireç ve tortuları özel makinelerimizle temizliyoruz. Isınma verimliliğinizi artırarak doğalgaz faturalarınızı düşürün.',
    features: [
      'Profesyonel petek temizleme makinesi',
      'Kombi bakımı ve temizliği',
      'Kat kaloriferi sistemleri',
      'Isıtma sistemi revizyonu',
      'Kış öncesi hazırlık'
    ],
    image: 'https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800',
    icon: 'thermometer'
  },
  {
    id: 'banyo-tadilat',
    title: 'Banyo Tadilatı',
    shortDesc: 'Rüya banyo için komple renovasyon',
    description: 'Kırma, tesisat, seramik, duşakabin montajından son rötuşlara kadar banyo tadilatınızı baştan sona tamamlıyoruz. Profesyonel ekip, kaliteli malzeme.',
    features: [
      'Komple kırma ve hazırlık',
      'Su ve pis su tesisatı',
      'Seramik ve fayans işleri',
      'Duşakabin, küvet montajı',
      'Anahtar teslim proje'
    ],
    image: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/m26divgf_IMG-20251113-WA0015.jpg',
    icon: 'bath',
    gallery: [
      'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/m26divgf_IMG-20251113-WA0015.jpg',
      'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/dlx3iiwn_IMG-20251113-WA0016.jpg',
      'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/fqydltzf_IMG-20251113-WA0012.jpg',
      'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/xlsizn8n_IMG-20251113-WA0013.jpg',
      'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/ysencvr2_IMG-20251113-WA0014.jpg'
    ]
  },
  {
    id: 'mutfak-tadilat',
    title: 'Mutfak Tadilatı',
    shortDesc: 'Modern mutfak düzenlemeleri',
    description: 'Mutfağınızı yeniden tasarlıyor, tesisat işlerinden dolap montajına, seramik işlerinden aydınlatmaya kadar tüm işleri gerçekleştiriyoruz.',
    features: [
      'Mutfak tesisat revizyonu',
      'Tezgah ve dolap montajı',
      'Seramik ve zemin kaplamaları',
      'Su tesisatı yenileme',
      'Fonksiyonel tasarım'
    ],
    image: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/pwdbe4xt_IMG-20251113-WA0021.jpg',
    icon: 'utensils',
    gallery: [
      'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/pwdbe4xt_IMG-20251113-WA0021.jpg'
    ]
  },
  {
    id: 'komple-tadilat',
    title: 'Komple Daire & İşyeri Tadilatı',
    shortDesc: 'Baştan sona tam renovasyon hizmeti',
    description: 'Daire ve işyerlerinizde tüm tadilat işlerini üstleniyoruz. Tesisat, elektrik, boya, zemin kaplama, asma tavan - her şey dahil. Havuz yapımı ve teras düzenlemelerinde de uzmanız.',
    features: [
      'Tesisat ve elektrik yenileme',
      'Zemin ve duvar kaplamaları',
      'Boya ve badana',
      'Asma tavan sistemleri',
      'Havuz yapımı ve teras düzenlemeleri',
      'Proje yönetimi'
    ],
    image: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/pfzlckwq_IMG-20251113-WA0020.jpg',
    icon: 'home',
    gallery: [
      'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/pfzlckwq_IMG-20251113-WA0020.jpg',
      'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/9mumcdxx_IMG-20251113-WA0017.jpg',
      'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/2a0e09aj_IMG-20251113-WA0018.jpg',
      'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/2v76fnx9_IMG-20251113-WA0019.jpg'
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Ayşe Yılmaz',
    location: 'Bayraklı, İzmir',
    rating: 5,
    comment: 'Banyomuzda su kaçağı vardı, evin her yerini kırmamız gerekir diye düşünüyorduk. EMRE TİCARET kırmadan buldu ve çözüm üretti. Hem zaman hem de para tasarrufu sağladık. Çok memnun kaldık!',
    date: '2024-01-15',
    service: 'Su Kaçağı Tespiti'
  },
  {
    id: 2,
    name: 'Mehmet Kaya',
    location: 'Bornova, İzmir',
    rating: 5,
    comment: 'Petek temizliği yaptırdık. Gerçekten de ısınma verimliliği arttı, doğalgaz faturamız düştü. Emre Bey ve ekibi çok profesyonel çalışıyor. İşlerini titizlikle yapıyorlar.',
    date: '2024-02-03',
    service: 'Petek Temizleme'
  },
  {
    id: 3,
    name: 'Zeynep Demir',
    location: 'Karşıyaka, İzmir',
    rating: 5,
    comment: 'Banyomuzu baştan aşağı yeniledik. İş bitiminden çok memnunuz. Kaliteli malzeme, titiz işçilik. Söz verdikleri sürede teslim ettiler. Herkese tavsiye ederim.',
    date: '2024-02-20',
    service: 'Banyo Tadilatı'
  },
  {
    id: 4,
    name: 'Ahmet Özkan',
    location: 'Konak, İzmir',
    rating: 5,
    comment: 'Mutfak lavabomuzun gideri tıkanmıştı. Aynı gün geldiler ve sorunu çözdüler. Hızlı ve güvenilir hizmet. Fiyatları da çok makul.',
    date: '2024-03-05',
    service: 'Kanal Açma'
  },
  {
    id: 5,
    name: 'Fatma Şahin',
    location: 'Bayraklı, İzmir',
    rating: 5,
    comment: 'Dairemizin tüm tesisatını yeniledik. Serkan Bey ve ekibi gerçekten işinin ehli. Her aşamayı detaylı anlattılar. Teşekkür ederiz.',
    date: '2024-03-18',
    service: 'Komple Tadilat'
  },
  {
    id: 6,
    name: 'Can Arslan',
    location: 'Buca, İzmir',
    rating: 5,
    comment: 'Su kaçağı için aradık, çok hızlı geldiler. Kameralı sistemle kaçağı buldular, aynı gün hallettiler. Gereksiz yere duvar kırmadılar. Süper!',
    date: '2024-03-25',
    service: 'Su Kaçağı Tespiti'
  },
  {
    id: 7,
    name: 'Elif Yıldız',
    location: 'Çiğli, İzmir',
    rating: 5,
    comment: 'Mutfağımızı yenilerken EMRE TİCARET ile çalıştık. Tesisat işlerinden dolap montajına kadar her şeyi hallettiler. Çok titiz ve düzenli çalışıyorlar.',
    date: '2024-04-02',
    service: 'Mutfak Tadilatı'
  },
  {
    id: 8,
    name: 'Mustafa Aydın',
    location: 'Gaziemir, İzmir',
    rating: 5,
    comment: 'Kombi bakımı ve petek temizliği için geldiler. İşlerini özenle yaptılar. Evde hiç kirlenmeden çıktılar. Kesinlikle tavsiye ediyorum.',
    date: '2024-04-10',
    service: 'Petek Temizleme'
  },
  {
    id: 9,
    name: 'Serpil Koç',
    location: 'Balçova, İzmir',
    rating: 5,
    comment: 'Ana kanalizasyon hattımızda ciddi bir tıkanıklık vardı. Görüntülü sistemle sorunu tespit edip çözdüler. Artık hiç sorun yaşamıyoruz.',
    date: '2024-04-15',
    service: 'Kanal Açma'
  },
  {
    id: 10,
    name: 'Hakan Erdoğan',
    location: 'Narlıdere, İzmir',
    rating: 5,
    comment: 'İşyerimizin tesisatını baştan yeniledik. Proje yönetiminden tutun da son kullanıma kadar her aşamada yanımızdalardı. Mükemmel hizmet!',
    date: '2024-04-22',
    service: 'Komple Tadilat'
  },
  {
    id: 11,
    name: 'Deniz Kılıç',
    location: 'Karşıyaka, İzmir',
    rating: 5,
    comment: 'Duşakabinimiz sızdırıyordu. Emre Bey geldi, sorunu hemen tespit etti ve aynı gün çözüme kavuşturdu. İşini bilen, güvenilir bir ekip.',
    date: '2024-05-01',
    service: 'Su Kaçağı Tespiti'
  },
  {
    id: 12,
    name: 'Aylin Şen',
    location: 'Bornova, İzmir',
    rating: 5,
    comment: 'Banyomuzun seramiklerini ve tesisat ını yeniledik. Çalışma süresince çok temiz ve düzenli çalıştılar. Sonuç harika oldu!',
    date: '2024-05-08',
    service: 'Banyo Tadilatı'
  },
  {
    id: 13,
    name: 'Burak Öztürk',
    location: 'Konak, İzmir',
    rating: 5,
    comment: 'Kış gelmeden önce petek temizliği yaptırdık. Fark çok belli oldu, evi daha hızlı ısıtıyor ve yakıttan tasarruf ettik.',
    date: '2024-10-12',
    service: 'Petek Temizleme'
  },
  {
    id: 14,
    name: 'Gizem Acar',
    location: 'Bayraklı, İzmir',
    rating: 5,
    comment: 'Evimizde su kaçağı vardı ama nereden olduğunu bulamıyorduk. EMRE TİCARET termal kamera ile hemen buldu. Kırmadan hallettiler, çok şükür!',
    date: '2024-10-20',
    service: 'Su Kaçağı Tespiti'
  },
  {
    id: 15,
    name: 'Okan Çelik',
    location: 'Buca, İzmir',
    rating: 5,
    comment: 'Dairemizin tüm tesisatını yeniledik, hem banyo hem mutfak. Kaliteli malzeme kullandılar ve işçilik garantisi verdiler. Çok memnunuz!',
    date: '2024-11-05',
    service: 'Komple Tadilat'
  },
  {
    id: 16,
    name: 'Selin Yaman',
    location: 'Çiğli, İzmir',
    rating: 5,
    comment: 'Lavabomuzun musluğu arızalandı, aynı gün geldiler ve yenisini taktılar. Hem hızlı hem de uygun fiyatlı. Teşekkürler EMRE TİCARET!',
    date: '2024-11-08',
    service: 'Tesisat Onarımı'
  },
  {
    id: 17,
    name: 'Cem Özer',
    location: 'Konak, İzmir',
    rating: 5,
    comment: 'İşyerimizin tuvaletinde su kaçağı vardı. Diğer firmalar duvarı kırmamız gerektiğini söyledi ama EMRE TİCARET kırmadan buldu ve çözüm üretti. Gerçekten profesyoneller.',
    date: '2024-11-10',
    service: 'Su Kaçağı Tespiti'
  },
  {
    id: 18,
    name: 'Pınar Arslan',
    location: 'Gaziemir, İzmir',
    rating: 5,
    comment: 'Duşakabinimizi yeniledik. Çok şık ve kaliteli bir iş çıktı. Montaj sırasında hiç sorun yaşamadık. İşlerinde titiz ve özenli çalışıyorlar.',
    date: '2024-11-12',
    service: 'Banyo Tadilatı'
  },
  {
    id: 19,
    name: 'Tolga Demirci',
    location: 'Bornova, İzmir',
    rating: 5,
    comment: 'Ana kanalizasyon hattımız tıkanmıştı, sokakta su birikiyordu. Görüntülü sistemle sorunu buldular ve açtılar. Artık hiç sorun yok. Çok teşekkürler!',
    date: '2024-11-14',
    service: 'Kanal Açma'
  },
  {
    id: 20,
    name: 'Gamze Tuncer',
    location: 'Karşıyaka, İzmir',
    rating: 5,
    comment: 'Kombimizin bakımını yaptırdık. Serkan Bey tüm parçaları kontrol etti, temizledi ve ayarladı. Şimdi çok daha verimli ısıtıyor. Her yıl yaptıracağız.',
    date: '2024-11-15',
    service: 'Kombi Bakımı'
  },
  {
    id: 21,
    name: 'Barış Kılıç',
    location: 'Bayraklı, İzmir',
    rating: 5,
    comment: 'Mutfak dolabımızın altından su sızıyordu. Hemen geldiler, sorunu tespit ettiler ve aynı gün hallettiler. Hızlı ve güvenilir bir ekip.',
    date: '2024-11-16',
    service: 'Su Kaçağı Tespiti'
  },
  {
    id: 22,
    name: 'Ebru Aksoy',
    location: 'Balçova, İzmir',
    rating: 5,
    comment: 'Villam ızın tüm peteklerini temizlettik. İnanılmaz kirli çıktı. Emre Bey ve ekibi çok özenli çalıştı. Isınma farkı hemen belli oldu. Kesinlikle tavsiye ederim!',
    date: '2024-10-25',
    service: 'Petek Temizleme'
  },
  {
    id: 23,
    name: 'Murat Demir',
    location: 'Narlıdere, İzmir',
    rating: 5,
    comment: 'Banyomuzun seramikleri çok eskimişti. Baştan sona yeniledik. İşçilik ve malzeme kalitesi mükemmel. Söyledikleri tarihte teslim ettiler.',
    date: '2024-10-30',
    service: 'Banyo Tadilatı'
  },
  {
    id: 24,
    name: 'Derya Yıldırım',
    location: 'Buca, İzmir',
    rating: 5,
    comment: 'Tuvaletimizin gideri sürekli tıkanıyordu. Kalıcı çözüm için geldiler, eski boruları yenilediler. Artık hiç sorun yaşamıyoruz. Çok memnun kaldık.',
    date: '2024-11-02',
    service: 'Kanal Açma'
  },
  {
    id: 25,
    name: 'Kemal Şahin',
    location: 'Konak, İzmir',
    rating: 5,
    comment: 'Ofisimizin mutfağını yeniledik. Tesisat işlerinden dolap montajına kadar her şeyi hallettiler. Çalışanlarımız çok memnun. EMRE TİCARET\'e teşekkürler!',
    date: '2024-11-06',
    service: 'Mutfak Tadilatı'
  }
];

export const blogPosts = [
  {
    id: 'evde-su-kacagi-belirtileri',
    title: 'Evde Su Kaçağı Nasıl Anlaşılır? 7 Temel Belirti',
    excerpt: 'Su kaçağının erken tespiti büyük hasarları önler. İşte evinizde su kaçağı olduğunu gösteren 7 önemli işaret...',
    content: 'Su kaçakları zamanında tespit edilmediğinde ciddi maddi zararlara yol açabilir. İşte dikkat etmeniz gereken belirtiler:\n\n1. **Su Faturasında Beklenmedik Artış**: Normal kullanımınızda değişiklik olmadığı halde faturanızın yükselmesi su kaçağının en belirgin işaretidir. Aylık faturanızı düzenli takip edin.\n\n2. **Duvarlarda Nem ve Rutubet**: Özellikle tesisat hatlarının geçtiği duvarlarda nemlenme, boya kabarması veya küflenme görülmesi su kaçağının açık belirtisidir. Duvarları düzenli kontrol edin.\n\n3. **Sürekli Su Sesi**: Musluklar kapalı olduğunda dahi su akışı sesi duyulması, borularda kaçak olduğunu gösterir. Gece sessiz saatlerde dinleyin.\n\n4. **Sayaç Hareketi**: Tüm muslukları kapatıp su sayacına baktığınızda sayacın dönmeye devam etmesi kesin kaçak işaretidir. Bu testi mutlaka yapın.\n\n5. **Zemin ve Tavanda Lekeler**: Kahverengi veya sarı lekeler, su birikintileri kaçağın göstergesidir. Özellikle banyo ve mutfak çevrelerini kontrol edin.\n\n6. **Sıcak Su Sisteminde Basınç Düşüşü**: Kombi sürekli çalışıyor ancak ısınma yeterli değilse, sistemde kaçak olabilir.\n\n7. **Kötü Kokular**: Nemden kaynaklanan küf ve rutubet kokusu, uzun süreli kaçağın sonucudur.\n\nBu belirtilerden birini fark ettiğinizde hemen profesyonel destek almanız önemlidir. EMRE TİCARET olarak kırmadan su kaçağı tespiti yapıyoruz.',
    image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=800',
    author: 'Emre Gürpınar',
    date: '2024-03-10',
    category: 'Su Kaçağı',
    tags: ['su kaçağı', 'tesisat', 'bakım']
  },
  {
    id: 'petek-temizligi-onemi',
    title: 'Kışa Girmeden Petek Temizliği Yaptırmanın Önemi',
    excerpt: 'Petek temizliği sadece hijyen değil, aynı zamanda enerji tasarrufu demektir. İşte detaylar...',
    content: 'Kış aylarına girmeden önce petek temizliği yaptırmak hem sağlığınız hem de cüzdanınız için kritik önem taşıyor.\n\n**Petek Temizliğinin Faydaları:**\n\n1. **Enerji Verimliliği**: Kirli petekler ısınma süresini uzatır ve daha fazla yakıt tüketimine neden olur. Temiz petekler %20-30 daha verimli çalışır. Bu da doğalgaz faturanıza direkt olarak yansır.\n\n2. **Sağlıklı Hava**: Peteklerdeki toz, bakteri ve küf havaya karışarak solunum problemlerine yol açabilir. Özellikle astım ve alerji hastaları için büyük risk oluşturur.\n\n3. **Uzun Ömür**: Düzenli bakım yapılan petekler ve kombi sistemleri daha uzun ömürlü olur. Sistemdeki kireç ve tortu birikimi ekipmanın ömrünü kısaltır.\n\n4. **Homojen Isınma**: Tüm petekler eşit şekilde ısınır, evin her köşesi rahat olur. Bazı odaların soğuk kalması sorunu ortadan kalkar.\n\n5. **Sessiz Çalışma**: Temiz petekler daha sessiz çalışır, borulardaki gürültü ve tıkırtı sesleri azalır.\n\n**Ne Zaman Yaptırmalı?**\n\nEylül-Ekim ayları ideal zamandır. Kış başlamadan sistemin hazır olmasını sağlar. Özellikle 2-3 yıldır temizlik yaptırmadıysanız mutlaka yaptırmalısınız.\n\n**Nasıl Yapılır?**\n\nProfesyonel petek temizleme makineleri ile peteklerin içindeki kireç ve tortu tamamen temizlenir. EMRE TİCARET olarak en son teknoloji ekipmanlarla hizmet veriyoruz. İşlem 2-4 saat sürer ve evinizde minimal rahatsızlık yaratır.',
    image: 'https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800',
    author: 'Serkan Gürpınar',
    date: '2024-02-25',
    category: 'Petek Temizleme',
    tags: ['petek', 'ısınma', 'enerji tasarrufu']
  },
  {
    id: 'banyoda-kotu-koku',
    title: 'Banyoda Kötü Koku Neden Olur, Nasıl Giderilir?',
    excerpt: 'Banyo kötü kokusu birçok nedenden kaynaklanabilir. Çözüm yollarını öğrenin.',
    content: 'Banyo kötü kokusu hem rahatsız edici hem de hijyen sorunu işaretidir.\n\n**Kötü Kokunun Sebepleri:**\n\n1. **Sifon Problemleri**: Klozet veya lavabo sifonundaki su bariyerinin azalması kanalizasyon kokusunun gelmesine neden olur. Uzun süre kullanılmayan banyolarda sifondaki su buharlaşabilir.\n\n2. **Tıkanık Giderler**: Saç, sabun artıkları, diş macunu gibi maddeler giderlerde birikerek koku yapar. Bu birikimler zamanla bakterilerin üremesine neden olur.\n\n3. **Havalandırma Yetersizliği**: Nemli ortam bakteri üremesine yol açar. Özellikle penceresiz banyolarda sorun daha ciddidir.\n\n4. **Eski Tesisatlar**: Çatlak veya eski borular koku yayılımına neden olur. Pas ve yıpranma koku kaynağı olabilir.\n\n5. **Duvar İçi Kaçaklar**: Duvar içindeki su kaçakları küf ve rutubet kokusu yapar. Bu en tehlikeli durumlardan biridir.\n\n6. **Hijyen Eksikliği**: Düzenli temizlik yapılmayan banyolarda bakteriler çoğalır ve kötü koku oluşturur.\n\n**Çözüm Yolları:**\n\n- Her gün en az 10 dakika havalandırma yapın\n- Giderleri haftada bir sıcak su ve karbonatla temizleyin\n- Sifon suyunu düzenli kontrol edin\n- Profesyonel kanal temizliği yaptırın (6 ayda bir)\n- Gerekirse tesisat yenileme yaptırın\n- Banyo duvarlarını kuru tutun\n\nKalıcı koku probleminiz varsa EMRE TİCARET ile iletişime geçin. Sorunun kaynağını bulup kalıcı çözüm üretiriz.',
    image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800',
    author: 'Emre Gürpınar',
    date: '2024-01-20',
    category: 'Tesisat',
    tags: ['banyo', 'tesisat', 'temizlik']
  },
  {
    id: 'mutfak-tadilati-ipuclari',
    title: 'Mutfak Tadilatı Öncesi Dikkat Etmeniz Gereken 5 Nokta',
    excerpt: 'Mutfak tadilatı büyük bir yatırımdır. Doğru planlama ile mükemmel sonuç alın.',
    content: 'Mutfak tadilatı hem fonksiyonel hem de estetik açıdan önemli bir projedir.\n\n**1. Bütçe Planlaması**\n\nGerçekçi bir bütçe belirleyin. Malzeme, işçilik ve beklenmedik giderler için %15-20 pay ayırın. Önceliklerinizi belirleyin: Tesisat mı, dolap mı, yoksa her ikisi mi?\n\n**2. Fonksiyonel Tasarım**\n\nMutfak üçgeni (ocak-buzdolabı-lavabo) prensibini uygulayın. Bu üç nokta arasındaki toplam mesafe 4-8 metre olmalı. Çalışma alanınız verimli olsun, gereksiz adım atmayın.\n\n**3. Tesisat ve Elektrik**\n\nYeni yerleşime göre su ve elektrik tesisatını planlayın. Geleceğe yönelik ihtiyaçları düşünün (bulaşık makinesi, çöp öğütücü vb.). Priz sayısını bol tutun.\n\n**4. Kaliteli Malzeme Seçimi**\n\nÖzellikle tezgah, musluk ve dolap menteşeleri için kaliteden ödün vermeyin. Uzun vadede kazandırır. Su tesisatında kaliteli boru ve fitting kullanın.\n\n**5. Profesyonel Destek**\n\nDeneyimli bir ekiple çalışın. EMRE TİCARET olarak mutfak tadilatında Adan Zye hizmet veriyoruz. Projelendirmeden uygulamaya kadar yanınızdayız.\n\n**Ek İpuçları:**\n- Aydınlatma planlaması kritiktir (tezgah, dolap içi, genel aydınlatma)\n- Depolama alanlarını maksimize edin\n- Kolay temizlenebilir malzemeler tercih edin\n- Havalandırma sistemini ihmal etmeyin (davlumbaz)\n- Zeminde kaymaz seramik kullanın',
    image: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800',
    author: 'Serkan Gürpınar',
    date: '2024-03-01',
    category: 'Tadilat',
    tags: ['mutfak', 'tadilat', 'dekorasyon']
  },
  {
    id: 'kanal-tikaniklarini-onleme',
    title: 'Kanal Tıkanıklıklarını Önlemenin 8 Yolu',
    excerpt: 'Kanal tıkanıklıkları en sık karşılaşılan tesisat sorunlarındandır. Önlemek mümkün!',
    content: 'Kanal tıkanıklıkları can sıkıcı ve maliyetli olabilir. İşte önlemenin yolları:\n\n**1. Yağları Gidere Dökmeyin**\n\nSıvı haldeyken sorun gibi görünmese de soğuduğunda boruları tıkar. Yağları kağıt havluya emdirebilir veya ayrı bir kapta toplayıp çöpe atabilirsiniz.\n\n**2. Saç Süzgeci Kullanın**\n\nDuş giderinde mutlaka saç süzgeci bulundurun. Haftada bir temizleyin. Saç, tıkanıklıkların en büyük nedenlerinden biridir.\n\n**3. Tuvalet Kağıdı Dışında Hiçbir Şey Atmayın**\n\nIslak mendil, pamuk, bez parçası gibi ürünler tuvalete atılmamalı. "Tuvalete atılabilir" yazan mendiller bile sorun yaratabilir.\n\n**4. Giderleri Düzenli Temizleyin**\n\nHaftada bir sıcak su ve karbonat ile giderleri temizleyin. Bu basit işlem büyük tıkanıklıkları önler.\n\n**5. Yemek Artıklarına Dikkat Edin**\n\nMutfak giderinden yemek artıkları göndermemeye özen gösterin. Lavabo süzgecini kullanın.\n\n**6. Sabun Artıklarını İhmal Etmeyin**\n\nKatı sabunlar zamanla birikerek tıkanıklık yapar. Ayda bir sıcak su ile giderleri açın.\n\n**7. Ağaç Kökleri Kontrolü**\n\nBahçenizde ağaç varsa, ana kanalizasyon hattınızı yılda bir kontrol ettirin. Kökler boruları patlatabilir.\n\n**8. Profesyonel Bakım**\n\nYılda bir kez profesyonel kanal temizliği yaptırın. EMRE TİCARET olarak görüntülü sistemlerle kanallarınızı temizliyoruz.',
    image: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=800',
    author: 'Emre Gürpınar',
    date: '2024-10-15',
    category: 'Tesisat',
    tags: ['kanal açma', 'bakım', 'önleyici bakım']
  },
  {
    id: 'banyo-yenileme-sureci',
    title: 'Banyo Yenileme Süreci: Adım Adım Rehber',
    excerpt: 'Banyo tadilatı nasıl yapılır? Tüm aşamaları detaylı anlattık.',
    content: 'Banyo yenileme büyük bir proje gibi görünebilir ama doğru planlama ile sorunsuz ilerler.\n\n**1. Planlama ve Tasarım (1-2 hafta)**\n\nÖnce ihtiyaçlarınızı belirleyin. Küvet mi duşakabin mi istiyorsunuz? Hangi renk ve stil? Pinterest ve magazinlerden ilham alın. Bütçenizi netleştirin.\n\n**2. Malzeme Seçimi (1 hafta)**\n\nSeramik, fayans, armatür, duşakabin, lavabo, klozet seçimlerini yapın. Kaliteli malzeme uzun vadede kazandırır. EMRE TİCARET olarak size en uygun malzemeleri önerebiliriz.\n\n**3. Kırma ve Hazırlık (1-2 gün)**\n\nEski seramikler, tesisatlar ve demirbaşlar söküldü. Bu aşama gürültülü olabilir. Tozdan korunmak için diğer odaların kapıları kapatılmalı.\n\n**4. Tesisat İşleri (2-3 gün)**\n\nSu ve pis su tesisatı yenileniyor. Bu en kritik aşamadır. Kaliteli boru ve ek parçaları kullanılmalı. Test edilmeden seramik döşenmemeli.\n\n**5. Elektrik İşleri (1 gün)**\n\nAydınlatma, priz ve fan bağlantıları yapılıyor. Su ile temas edebilecek bölgelerde özel dikkat gerekir.\n\n**6. Duvar ve Zemin Hazırlığı (1 gün)**\n\nYüzeyler düzeltiliyor, su yalıtımı yapılıyor. Bu aşama atlanmamalı.\n\n**7. Seramik Döşeme (3-4 gün)**\n\nDuvar ve zemin seramikleri döşeniyor. Derz işlemi yapılıyor. En az 24 saat kurumaya bırakılıyor.\n\n**8. Montaj İşleri (1-2 gün)**\n\nKlozet, lavabo, duşakabin, aynalık montajı yapılıyor.\n\n**9. Son Rötuşlar (1 gün)**\n\nTemizlik, silikon çekme, test işlemleri.\n\n**Toplam Süre:** Ortalama 10-14 gün',
    image: 'https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/m26divgf_IMG-20251113-WA0015.jpg',
    author: 'Serkan Gürpınar',
    date: '2024-11-01',
    category: 'Tadilat',
    tags: ['banyo', 'renovasyon', 'adım adım']
  }
];

export const faqs = [
  {
    id: 1,
    question: 'Su kaçağı tespiti için duvarları kırmak gerekir mi?',
    answer: 'Hayır, kesinlikle gerek yoktur. Modern teknolojimiz sayesinde termal kamera, akustik dinleme cihazları ve kameralı görüntüleme sistemlerimizle kaçak noktasını kırmadan milimetre hassasiyetle tespit ediyoruz. Sadece tespit edilen noktada minimal müdahale yapılır, gereksiz yere duvarlarınızı kırmayız. Bu sayede hem zaman hem de maliyet tasarrufu sağlamış olursunuz.'
  },
  {
    id: 2,
    question: 'Aynı gün hizmet alabilir miyim?',
    answer: 'Evet, acil durumlar için mutlaka aynı gün hizmet veriyoruz. Özellikle su kaçağı, tıkanıklık ve kombi arızası gibi acil durumlarda ekibimiz en kısa sürede size ulaşır ve sorununuzu çözer. İzmir genelinde hızlı ulaşım ağımız sayesinde çoğu durumda 1-2 saat içinde adresinizde oluyoruz. 7/24 arayabilirsiniz.'
  },
  {
    id: 3,
    question: 'Petek temizliği ne kadar sürer?',
    answer: 'Ortalama bir daire için petek temizliği 2-4 saat arasında sürmektedir. Petek sayısı, sistemin durumu ve kirliliğe göre bu süre değişiklik gösterebilir. Büyük villalar veya çok petekli sistemlerde 5-6 saat sürebilir. İşlem sırasında evinizde olmanız gerekmez, güvenle bize bırakabilirsiniz. Temizlik sonrası test işlemlerini yaparak size teslim ediyoruz.'
  },
  {
    id: 4,
    question: 'Banyo tadilatı ne kadar sürer?',
    answer: 'Standart bir banyo tadilatı 7-10 gün arası sürmektedir. Bu süre; kırma, tesisat yenileme, seramik döşeme, montaj ve son rötuşları içerir. Daha büyük banyolar veya özel tasarımlar 12-15 gün sürebilir. İlk keşifte projenizi inceleyip size net süre bilgisi veriyoruz. Planlanan tarihte işi bitirmeyi garantiliyoruz.'
  },
  {
    id: 5,
    question: 'Hangi bölgelere hizmet veriyorsunuz?',
    answer: 'Bayraklı merkezli olarak tüm İzmir ilçelerine hizmet veriyoruz. Konak, Karşıyaka, Bornova, Buca, Balçova, Çiğli, Gaziemir, Narlıdere, Güzely alı, Mende, Urla, Foça, Dikili ve diğer tüm ilçelere ekibimiz ulaşıyor. İzmir dışı için lütfen arayarak bilgi alın. Uzak bölgelere de özel projelerde gidiyoruz.'
  },
  {
    id: 6,
    question: 'Kullandığınız malzemeler garantili mi?',
    answer: 'Evet, kullandığımız tüm malzemeler orijinal, belgeli ve garantilidir. Türkiye\'nin önde gelen markalarıyla çalışıyoruz. Ayrıca işçiliğimiz için de 2 yıl garanti veriyoruz. Tesisat işlerinde kullandığımız borular, ekler, vanalar, musuluklar hepsi kaliteli ve uzun ömürlüdür. Garanti belgelerinizi muhafaza etmenizi öneriyoruz.'
  },
  {
    id: 7,
    question: 'Fiyat teklifi ücretsiz mi?',
    answer: 'Keşif ve fiyat teklifi tamamen ücretsizdir. İzmir genelinde ücretsiz keşif hizmeti veriyoruz. WhatsApp üzerinden fotoğraf ve video göndererek de ön bilgi alabilirsiniz. Fiyat tekliflerimiz net ve şeffaftır, gizli masraf yoktur. Teklifi beğenmezseniz hiçbir ücret ödemezsiniz.'
  },
  {
    id: 8,
    question: 'Ödeme şekilleri nelerdir?',
    answer: 'Nakit, havale/EFT ve tüm banka kredi kartları ile ödeme kabul ediyoruz. Büyük projelerde %50 kapora, %50 iş bitiminde olmak üzere 2 taksitli ödeme yapabilirsiniz. Ayrıca anlaşmalı olduğumuz bankalar üzerinden 3, 6, 9 taksit imkanlarımız da mevcuttur. Ödeme koşullarını keşif sırasında detaylı görüşürüz.'
  },
  {
    id: 9,
    question: 'Kanal tıkanıklığı ne kadar sürede açılır?',
    answer: 'Çoğu kanal tıkanıklığı 1-2 saat içinde açılır. Basit tıkanıklıklar 30 dakika içinde hallolurken, ana kanalizasyon hattındaki ciddi tıkanıklıklar 3-4 saat sürebilir. Görüntülü kameralı sistemlerimizle sorunu tespit edip en etkili yöntemi uyguluyoruz. Acil durumlarda aynı gün hizmet veriyoruz.'
  },
  {
    id: 10,
    question: 'Kombi bakımı neden önemlidir?',
    answer: 'Kombi bakımı hem güvenlik hem de verimlilik açısından kritik önemde. Yılda bir kez mutlaka yaptırılmalıdır. Bakımsız kombiler daha fazla gaz tüketir, daha az ısıtır ve arıza riski yüksektir. Ayrıca karbon monoksit zehirlenmesi gibi hayati tehlikeler oluşturabilir. Bakım sırasında tüm parçalar kontrol edilir, temizlenir ve ayarlanır. Garanti süresi içindeki kombilerde yetkili servis bakımı zorunludur.'
  },
  {
    id: 11,
    question: 'Tadilat sırasında evde olmak zorunda mıyım?',
    answer: 'İlk gün malzemelerin teslimi ve çalışma planının konuşulması için bulunmanız iyi olur. Sonraki günlerde evde olmanız şart değil. Güvenilir ekibimiz evlerinize özenle çalışır, temiz ve düzenli bırakır. Günlük çalışma fotoğraflarını size WhatsApp üzerinden göndeririz. İsterseniz anahtar teslimi çalışabiliriz.'
  },
  {
    id: 12,
    question: 'Hangi markaların ürünlerini kullanıyorsunuz?',
    answer: 'Viko, Schneider, Eca, Emas, Creavit, Kale, Bien, Artema, Grohe gibi Türkiye\'nin köklü ve güvenilir markalarıyla çalışıyoruz. Müşteri tercihlerin göre farklı segmentlerde ürün sunuyoruz. İstediğiniz marka ve model varsa temin edip monte ediyoruz. Kalitesiz, markaısz, sertifikas ürünler kullanmıyoruz.'
  }
];

export const campaigns = [
  {
    id: 1,
    title: 'Temiz su kaçakları kırmadan bulunur!',
    description: 'Gereksiz masraf ve zaman kaybı yaşamayın.',
    active: true
  }
];
